import { Component, Input, OnInit } from '@angular/core';
import { DeviationSeverity, DeviationSubjectType } from '../types';

@Component({
  selector: 'deviation',
  templateUrl: './deviation.component.html',
  styleUrls: ['./deviation.component.scss']
})
export class DeviationComponent implements OnInit {
  @Input() count: number = 0
  @Input() subject: number = DeviationSubjectType.order
  @Input() subjectId: number = 0
  @Input() description: string = ''
  @Input() severity: number=DeviationSeverity.warning
  @Input() IDPosition: number = 0

  constructor() { }

  ngOnInit(): void {
  }

  readonly DeviationSeverity=DeviationSeverity
}
